/**
 * Hook to sync user's FTUX status with Redux state
 * Call this hook at the app root level (e.g., in Layout component)
 * to keep FTUX state in sync with user data from API
 */

import { useEffect } from 'react';
import { useAppDispatch } from '../../store/slice';
import { FtuxSlice } from '../../store/slice/Ftux';
import { UserType } from '../../store/slice/User';

export const useFtuxSync = (user: UserType | null) => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (user?.loggedIn) {
			dispatch(
				FtuxSlice.actions.setUserFtuxStatus({
					onboardingCompleted: user.ftuxCompleted ?? true,
					tutorials: user.tutorials || []
				})
			);
		}
	}, [user?.ftuxCompleted, user?.tutorials, dispatch, user?.loggedIn]);
};
